import Displacement from './displacement-components/Displacement';
import './sec12.css';
// import Redlining from "./redlining-components/Redlining";
// import Area from "./area-components/Area";

const Sec12 = () => {
    return (
        <div className="sec12-section">

            <span style={{ paddingTop: "300px"}}>Displacement in Boston involves the forced relocation of residents,</span>
            <span>frequently from lower-income or marginalized communities, due to rising </span>
            <span style={{paddingBottom:"200px"}}>living cost, development pressures, and gentrification.</span>
            
            <div id="displacement">
                <Displacement />
            </div>
            
        </div>
    );
};

export default Sec12;
